import "cally";

// Frontpage hero ("Forside toppmodul"): pick a city + optional date, then
// navigate to that destination page. Scoped per block instance and kept
// separate from _calendar-component.js (which is a single-instance, product
// filtering calendar) to avoid global querySelector clashes.
document.querySelectorAll(".frontpage-hero").forEach((hero) => {
    const citySelect = hero.querySelector("#fph-city");
    const dateField = hero.querySelector(".frontpage-hero__field--date");
    const dateTrigger = hero.querySelector(".frontpage-hero__date-trigger");
    const calendarWrap = hero.querySelector(".frontpage-hero__calendar");
    const calendar = hero.querySelector("calendar-range");
    const dateText = hero.querySelector(".frontpage-hero__date-text");
    const submit = hero.querySelector(".frontpage-hero__submit");

    let selectedFrom = "";
    let selectedTo = "";

    const lang = document.documentElement.lang || "";
    const isNb = lang.startsWith("nb") || lang.startsWith("no");
    const locale = isNb ? "nb-NO" : "en-GB";

    const monthName = (y, m) =>
        new Intl.DateTimeFormat(locale, { month: "long", timeZone: "UTC" }).format(
            new Date(Date.UTC(y, m - 1, 1))
        );

    // Day token: Norwegian appends a trailing dot ("16."), English does not ("16")
    const day = (d) => (isNb ? `${d}.` : `${d}`);

    // Single date, e.g. "16. juli 2026" / "16 July 2026"
    const singleDate = ([y, m, d]) => `${day(d)} ${monthName(y, m)} ${y}`;

    // Compact, language-aware range that collapses a shared month/year
    const formatRange = (fromIso, toIso) => {
        const from = fromIso.split("-").map(Number); // [y, m, d]
        if (!toIso || toIso === fromIso) {
            return singleDate(from);
        }
        const to = toIso.split("-").map(Number);
        const [y1, m1, d1] = from;
        const [y2, m2, d2] = to;

        if (y1 === y2 && m1 === m2) {
            // Same month & year: "16.–18. juli 2026" / "16–18 July 2026"
            return `${day(d1)}–${day(d2)} ${monthName(y1, m1)} ${y1}`;
        }
        if (y1 === y2) {
            // Same year, different month: "28. juni – 3. juli 2026"
            return `${day(d1)} ${monthName(y1, m1)} – ${singleDate(to)}`;
        }
        // Different year: both dates in full
        return `${singleDate(from)} – ${singleDate(to)}`;
    };

    const closeCalendar = () => {
        if (!calendarWrap) return;
        calendarWrap.classList.add("hidden");
        if (dateTrigger) dateTrigger.setAttribute("aria-expanded", "false");
    };

    if (dateTrigger && calendarWrap) {
        dateTrigger.addEventListener("click", (event) => {
            event.stopPropagation();
            const isHidden = calendarWrap.classList.toggle("hidden");
            dateTrigger.setAttribute("aria-expanded", String(!isHidden));
        });
    }

    if (calendar) {
        calendar.addEventListener("change", (event) => {
            const value = event.target.value || ""; // "YYYY-MM-DD/YYYY-MM-DD"
            const parts = value.split("/");
            selectedFrom = parts[0] || "";
            selectedTo = parts[1] || "";

            if (selectedFrom && dateText) {
                dateText.textContent = formatRange(selectedFrom, selectedTo);
            }
            // Calendar stays open during range selection; it closes on outside click.
        });
    }

    // Close the calendar when clicking outside the date field
    document.addEventListener("click", (event) => {
        if (
            calendarWrap &&
            !calendarWrap.classList.contains("hidden") &&
            dateField &&
            !dateField.contains(event.target)
        ) {
            closeCalendar();
        }
    });

    if (submit) {
        submit.addEventListener("click", () => {
            if (!citySelect || !citySelect.value) return;

            let url;
            try {
                url = new URL(citySelect.value, window.location.origin);
            } catch (error) {
                return;
            }

            if (selectedFrom) {
                url.searchParams.set("from", selectedFrom);
            }
            if (selectedTo) {
                url.searchParams.set("to", selectedTo);
            }

            window.location.href = url.toString();
        });
    }
});
